import React, { useEffect, useState } from "react";
import { fetchGetCustomer } from "../api";
import { isTestEnv } from "../utils/env";
import iconProducts from "../assets/img/icon_products.svg";
import itemDx from "../assets/img/item_dx_noborder.png";
import itemZakuro from "../assets/img/item_zakuro_noborder.png";
import itemBifi from "../assets/img/item_bifi_noborder.png";

const LP_BASE = isTestEnv()
  ? "https://www.kotohogi.co.jp/test"
  : "https://www.kotohogi.co.jp";

const products = [
  {
    name: "山野草醗酵酵素\nブルーベリーDX",
    image: itemDx,
    lpUrl: `${LP_BASE}/lps/blueberry/dx7berryz/#input_form`,
  },
  {
    name: "山野草醗酵酵素\n若榴da檸檬",
    image: itemZakuro,
    lpUrl: `${LP_BASE}/lps/zakuro/zak200/#input_form`,
  },
  {
    name: "わたしの毎日ビフィズス菌\nビフィずっと",
    image: itemBifi,
    lpUrl: `${LP_BASE}/lps/bifi/bifizutto/`,
  },
];

const Products = () => {
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) return;
    fetchGetCustomer(token).then((res) => {
      if (res) setCustomer(res);
    });
  }, []);

  const handleOrder = (product) => {
    if (!customer) return;

    const [sei = "", mei = ""] = (customer.customer_name || "").split(/\s+/);
    const tel = customer.phone_number_1 || "";
    const [tel1 = "", tel2 = "", tel3 = ""] = tel.split("-");

    // 非表示フォームを作成してPOST送信
    const form = document.createElement("form");
    form.method = "POST";
    form.action = product.lpUrl;
    form.target = "_blank";

    const fields = {
      sei, mei,
      seikana: "", meikana: "",
      zip: customer.postal_code || "",
      add1: customer.prefecture_name || "",
      add2: customer.municipality_name || "",
      add3: `${customer.town_name || ""} ${customer.address_number || ""}`.trim(),
      add4: `${customer.address_detail_1 || ""} ${customer.address_detail_2 || ""}`.trim(),
      tel1, tel2, tel3,
      email: customer.email || "",
      account: customer.member_id_1 || "",
      account2: customer.member_id_2 || "",
    };

    Object.entries(fields).forEach(([key, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  return (
    <section className="section product-section">
      <h2 className="section-title">
        <i>
          <img src={iconProducts} alt="" />
        </i>
        商品一覧
      </h2>

      <div className="product-grid">
        {products.map((product, index) => (
          <div className="product-card" key={index}>
            <div className="product-image" onClick={() => handleOrder(product)} style={{ cursor: "pointer" }}>
              <img src={product.image} alt={product.name.replace("\n", " ")} />
            </div>
            <p className="product-name" style={{ whiteSpace: "pre-line" }}>{product.name}</p>
            <button
              type="button"
              className="product-order-btn"
              onClick={() => handleOrder(product)}
            >
              ご注文はこちら
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Products;
